module.exports = __webpack_public_path__ + "img/crazy-time.1b86680.webp";